import { useState } from "react";
import { useIntl } from "react-intl";
import { NectaryIcon } from "../Icon";
import { useSidebarState } from "../NavigationBar/state";
import { useAccountSwitcherContext } from "./AccountSwitcherContext";
import { AccountSwitcherTree } from "./components/AccountSwitcherTree/AccountSwitcherTree";

import {
  StyledTrigger,
  ExpandedTrigger,
  TextWrapper,
  TriggerWrapper,
  IconWrapper,
} from "./styled";

import "@nectary/components/popover";
import "@nectary/components/text";
import "@nectary/components/tooltip";

export const NavigationAccountSwitcher = () => {
  const { isCollapsed } = useSidebarState();
  const [show, setShow] = useState<boolean>(false);
  const intl = useIntl();
  const { setSearchBarFocus, setSearchValue, currentAccount } =
    useAccountSwitcherContext();

  const toggleShow = () => {
    if (show) {
      setSearchBarFocus(false);
      setSearchValue("");
    }
    setShow((prevState) => !prevState);
  };

  return (
    <sinch-popover
      aria-label="account-switcher"
      open={show}
      modal
      orientation="bottom-right"
      on-close={toggleShow}
    >
      <TriggerWrapper
        isCollapsed={isCollapsed}
        onClick={toggleShow}
        aria-label={intl.formatMessage({ id: "accountSwitcherTitle" })}
        slot="target"
      >
        <ExpandedTrigger>
          <StyledTrigger
            isCollapsed={isCollapsed}
            clickable
            showTooltip={!show}
          />
          {!isCollapsed && (
            <>
              <TextWrapper>
                <sinch-tooltip
                  text={currentAccount.accountName || ""}
                  orientation={"top"}
                >
                  <sinch-text
                    type="s"
                    style={{
                      maxWidth: "121px",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      fontSize: "var(--sinch-ref-typography-font-size-14)",
                      fontWeight: "var(--sinch-ref-typography-font-weight-700)",
                      lineHeight: "var(--sinch-ref-typography-line-height-16)",
                    }}
                  >
                    {currentAccount.accountName}
                  </sinch-text>
                </sinch-tooltip>
              </TextWrapper>
              <IconWrapper>
                <NectaryIcon name="keyboard-arrow-down" />
              </IconWrapper>
            </>
          )}
        </ExpandedTrigger>
      </TriggerWrapper>

      <AccountSwitcherTree slot="content" />
    </sinch-popover>
  );
};
